module.exports = __webpack_public_path__ + "img/mes_en.319d37eb.png";